import getAuthorityLevel from 'app/utils/getAuthorityLevel';
import React, { useEffect, useRef, useState } from 'react';
import YouTube from 'react-youtube';

export default function YouTubePlayer(props) {
  const { disclaimerModal, setFinishVideoModal, unansweredQuestions, videoId, intervalId, setIntervalId, onUpdateProgress, setUpdateContentNow, showQuizModal, setShowQuizModal, selectedItem, setCurrentQuiz } = props;
  const videoRef = useRef(null);
  const percent = useRef(null);
  const authorityLevel = getAuthorityLevel();
  const youtubeOpts = {
    height: '100%',
    width: '100%',
    playerVars: {
      autoplay: 0
    }
  };
  const [player, setPlayer] = useState(null);
  const [count, setCount] = useState(0);
  const [lastModalOpenTime, setLastModalOpenTime] = useState(0);

  useEffect(() => {
    if ((!showQuizModal || !disclaimerModal) && player) {
      player.playVideo();
    }
  }, [showQuizModal, disclaimerModal]);

  const parsedQuiz = selectedItem?.['quiz-items']?.map(item => {
    const time = item.duration;
    const parts = time.split(':');
    const hours = parseInt(parts[0], 10) * 3600;
    const minutes = parseInt(parts[1], 10) * 60;
    const seconds = parseInt(parts[2], 10);
    const totalSeconds = hours + minutes + seconds;
    return {
      body: item.body,
      id: item.id,
      duration: totalSeconds,
      'quiz-item-alternatives': item['quiz-item-alternatives'],
      taxonomies: item.taxonomies
    };
  });

  const openModalTimings = parsedQuiz?.map(item => item.duration);

  const onReady = e => {
    // e.target.playVideo();
    videoRef.current = e.target;

    callInterval();
    setPlayer(e.target);
  };

  const onPause = () => clearInterval(intervalId);

  const callInterval = event => {
    clearInterval(intervalId);
    setIntervalId(setInterval(() => checkProgress(), 100));
    if (event?.target?.getPlayerState() === 1) {
      setTimeout(() => setCount(0), 2000);
    }
  };

  const checkProgress = async () => {
    const e = videoRef.current;
    const videoCurrentTime = parseInt(e.getCurrentTime());
    const videoDuration = parseInt(e.getDuration());

    if (videoCurrentTime === videoDuration - 2 && unansweredQuestions.length > 0 && count === 0) {
      setFinishVideoModal(true);
      setShowQuizModal(true);
      setCurrentQuiz(unansweredQuestions[0]);
      player.pauseVideo();
      setCount(prevState => prevState + 1);
    }

    if (openModalTimings?.includes(Math.floor(videoCurrentTime))) {
      setCurrentQuiz(parsedQuiz?.find(item => item.duration == Math.floor(videoCurrentTime)));
      if (videoCurrentTime !== lastModalOpenTime) {
        setCount(count + 1);
        setShowQuizModal(true);
        player?.pauseVideo();

        if (document.fullscreenElement !== null) {
          document.exitFullscreen();
        }
        setLastModalOpenTime(videoCurrentTime);
      }
    }

    const percentage = parseFloat((videoCurrentTime * 100) / videoDuration).toFixed(2);

    if (authorityLevel === 'student') {
      if (percent.current !== percentage && videoCurrentTime === videoDuration - 1) {
        const parsedPercentage = percentage >= 80 ? 100 : percentage;
        await onUpdateProgress(parsedPercentage);
        setUpdateContentNow(true);
        // } else if (percent.current !== percentage && percentage > 0 && percentage % 5 == 0) {
        //   onUpdateProgress(percentage);
      }

      if (videoCurrentTime === videoDuration - 1) {
        clearInterval(intervalId);
      }
    }
    percent.current = percentage;
  };

  return (
    <YouTube
      videoId={videoId}
      opts={youtubeOpts}
      onReady={onReady}
      onPause={onPause}
      onPlay={callInterval}
      // onEnd={checkProgress}
      // onStateChange={callInterval}
    />
  );
}
